exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-design-tool-container[data-v-18149f12]{display:block}.insert-text[data-v-18149f12]{display:none}.disabled[data-v-18149f12]{opacity:.4}.element-custom.classification[data-v-18149f12]{margin-top:.175rem;color:#9e9e9e;font-size:85%}", ""]);

// exports
